/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { FlexGrid } from '@/components/FlexGrid/FlexGrid';
import { Skeleton, View } from '@az/starc-ui';

export function StoreCardSkeleton() {
  return (
    <View
      attributes={{
        'data-testid': 'store-card-skeleton',
        style: { backgroundColor: '#F2F2F2' },
      }}
    >
      <FlexGrid flexDirection="column" gap={4} padding={20}>
        <Skeleton height="24px" width="100%" />
        <Skeleton height="24px" width="50%" />
        <Skeleton height="48px" width="50%" />
        <Skeleton height="24px" width="100%" />

        <FlexGrid gap={2}>
          <Skeleton height="44px" width="100%" />
          <Skeleton height="44px" width="100%" />
        </FlexGrid>
      </FlexGrid>
    </View>
  );
}
